module.exports = __webpack_public_path__ + "img/ic_topic_recipe.60c1889e.svg";